export default "/_next/static/images/whatsapp-icon-1c92f5f158bf452aadd2372bfb437b27.svg";